import type { IconSize } from './Icon.types';

export const IconPixelSize: { [key in IconSize]: number } = {
  l: 24,
  m: 20,
  s: 16,
};
